import React, { useEffect } from 'react'
import { useState } from "react"
import { firestore } from "../../../../../firebase"
import RemoveUtenlandsProff from './RemoveUtenlandsProff'

function AddUtenlandsProff({player}) {

	const [isAdded, setIsAdded] = useState(false)
    const [proffId, setProffId] = useState()

	async function addProffHandler(e) {
		e.preventDefault()
		if (!player) {
			console.log("No player")
			return
		}
		try {
			const utenlandsProffRef = firestore.collection("utenlandsproffer")
			const data = {
				api_data: player,
				league_id: player?.league_id,
				player_id: player?.player_id,
				player_name: player?.player_name,
				team_id: player?.team_id
			}
            utenlandsProffRef.add(data)
            setIsAdded(true)
		} catch (error) {
			console.log(error)
		}
	}

	useEffect(() => {

		try {
			const proffRef = firestore.collection("utenlandsproffer");
			proffRef.where("player_id", "==", player.player_id).onSnapshot(({docs}) => {
				const proffer = docs.map(doc => {
					return {id: doc.id, ...doc.data()}
				})
				console.log(proffer)
				if (proffer?.length) {
					setIsAdded(true)
					setProffId(proffer[0]?.id)
				}
			})
		} catch (error) {

		}

	}, [player])

	return (
		<div>
			{!isAdded && (
                <form onSubmit={addProffHandler}>

                    <button className="btn btn-success btn-block">Legg til utenlandsproff</button>

                </form>
			)}
            {isAdded && <React.Fragment>
                <div className="alert alert-success">Proff lagt til</div>
                {proffId && <RemoveUtenlandsProff proffId={proffId} setIsAdded={setIsAdded} />}
                </React.Fragment>}
		</div>
	)
}
export default AddUtenlandsProff
